import { useEffect } from "react";

const GoogleTag = () => {
  useEffect(() => {
    // Load the Google Tag script
    const script1 = document.createElement("script");
    script1.async = true;
    script1.src = "https://www.googletagmanager.com/gtag/js?id=AW-17653123534";
    document.head.appendChild(script1);

    // Initialize gtag
    const script2 = document.createElement("script");
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-17653123534');
    `;
    document.head.appendChild(script2);
  }, []);

  return null; // this component doesn't render anything visible
};

export default GoogleTag;
